/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnChanges, type OnInit, Component, EventEmitter, Input, Output } from '@angular/core';

import { AlarmsAndEventsService } from '../alarms-and-events.service';
import { AlarmsAndEventsStrService } from '../alarms-and-events-str.service';

@Component({
    selector: 'app-alarms-setting',
    templateUrl: './alarms-setting.component.html',
    styleUrls: ['.//alarms-setting.component.scss'],
})
export class AlarmsSettingComponent implements OnInit, OnChanges {
    @Input() show: boolean;
    @Output() settingSave = new EventEmitter<any>();

    @Output() showChange = new EventEmitter<boolean>();

    levelText = this.str.levelText;
    cancelBtnLabel = this.str.detailsLabelText.cancelBtn;
    saveBtnLabel = this.str.detailsLabelText.saveBtn;
    settingTitle = this.str.setAlarmBuzzeTitle;
    instrction = this.str.setAlarmBuzzerInstruction;
    alarmLevel = this.str.alarmLevel;

    criticalValue: boolean;
    majorValue: boolean;
    warningValue: boolean;
    minAlarmLevel: number;
    alarmVoiceEnabled: boolean;

    constructor(
        private str: AlarmsAndEventsStrService,
        private service: AlarmsAndEventsService,
    ) { }

    ngOnInit(): void {
        this.setCheck();
     }

    ngOnChanges(): void {
        this.setCheck();
    }

    setCheck(): void {
        [this.alarmVoiceEnabled, this.minAlarmLevel] = this.service.getAlarmsSettings();
        switch (this.minAlarmLevel) {
            case 0:
            this.criticalValue = this.majorValue = this.warningValue = false;
                break;
            case 3:
            this.criticalValue = this.majorValue = this.warningValue = true;
                break;
            case 5:
            this.criticalValue = this.majorValue = true;
            this.warningValue = false;
                break;
            case 6:
            this.criticalValue = true;
            this.majorValue = this.warningValue = false;
                break;
            default:
                break;
        }
    }

    onCriticalChange($event): void {
        if (!$event) {
            this.majorValue = false;
            this.warningValue = false;
        }
    }

    onMajorChange($event): void {
        if ($event) {
            this.criticalValue = true;
        } else {
            this.warningValue = false;
        }
    }

    onWarningChange($event): void {
        if ($event) {
            this.criticalValue = true;
            this.majorValue = true;
        }
    }

    onClose(): void {
        this.show = false;
        this.settingSave.emit();
    }

    onSave(): void {
        this.show = false;
        this.service.setAlarmsSettings(this.alarmVoiceEnabled, this.getSoundType());
        this.settingSave.emit();
    }

    getSoundType(): number {
        if (this.warningValue) {
            return 3;
        } else if (this.majorValue) {
            return 5;
        } else if (this.criticalValue) {
            return 6;
        } else {
            return 0;
        }
    }
}
